import {post,get} from '../index'
export const getUser={
    getSubordinate(){
        return get('/user/subordinate')
    },
    getSubordinateOrders(params){
        return get('/user/subordinate_orders',params)
    },
    // 用户数据
    getUse(params){
        return get('user/info')
    },
    // 是否签到
    getTodaysign(params){
        return get('user/todaysign')
    },
    // 签到
    getSign(params){
        return post('user/sign')
    },
    getRegister(params){
        return post('user/register',params)
    }
}


// WEBPACK FOOTER //
// ./src/api/http/user.js